export const SW_VERSION = "524c77811e9aaeed1a3a3c14be0af453";